import { ALLERGENS, allergenLabel, DIET_TAGS, dietLabel } from "@/lib/allergens";

export function DietTagPicker({ value = [], onChange }) {
  const toggle = (code) => onChange(value.includes(code) ? value.filter((c) => c !== code) : [...value, code]);
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="diet-picker">
      {DIET_TAGS.map((t) => {
        const on = value.includes(t.code);
        return (
          <button key={t.code} type="button" onClick={() => toggle(t.code)} aria-pressed={on}
            className={`px-2.5 h-8 rounded-full text-xs font-medium border transition-colors ${on ? "bg-[#5aa469] border-[#5aa469] text-white" : "border-gray-200 text-gray-600 hover:border-[#5aa469]/60"}`}
            data-testid={`diet-${t.code}`}>{t.label}</button>
        );
      })}
    </div>
  );
}

export function DietBadges({ codes = [] }) {
  if (!codes.length) return null;
  return (
    <span className="inline-flex flex-wrap gap-1 ml-1 align-middle" data-testid="diet-badges">
      {codes.map((c) => <span key={c} className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-[#5aa469]/12 text-[#3f7a4a]">{dietLabel(c)}</span>)}
    </span>
  );
}

export function AllergenPicker({ value = [], onChange }) {
  const toggle = (code) => onChange(value.includes(code) ? value.filter((c) => c !== code) : [...value, code]);
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="allergen-picker">
      {ALLERGENS.map((a) => {
        const on = value.includes(a.code);
        return (
          <button key={a.code} type="button" onClick={() => toggle(a.code)} aria-pressed={on}
            className={`px-2.5 h-8 rounded-full text-xs font-medium border transition-colors ${on ? "bg-amber-500 border-amber-500 text-white" : "border-gray-200 text-gray-600 hover:border-amber-300"}`}
            data-testid={`allergen-${a.code}`}>{a.label}</button>
        );
      })}
    </div>
  );
}

export function AllergenBadges({ codes = [], compact = false, accent }) {
  if (!codes.length) return null;
  return (
    <p className={`flex flex-wrap items-center gap-1 ${compact ? "mt-0.5" : "mt-1.5"}`} data-testid="allergen-badges">
      <span className="text-[11px] uppercase tracking-wide text-amber-700 font-semibold mr-0.5">Allergeni:</span>
      {codes.map((c) => (
        <span key={c} className="text-[11px] px-1.5 py-0.5 rounded bg-amber-50 text-amber-800 border border-amber-100" style={accent ? undefined : {}}>{allergenLabel(c)}</span>
      ))}
    </p>
  );
}
